"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonIconPosition = exports.ButtonStyle = exports.ButtonSize = exports.ButtonType = exports.ButtonColor = void 0;
var ButtonColor;
(function (ButtonColor) {
    ButtonColor["DigitalBlack"] = "digital-black";
    ButtonColor["ThemePrimary"] = "themePrimary";
    ButtonColor["ThemeSecondary"] = "themeSecondary";
    ButtonColor["ThemeTertiary"] = "themeTertiary";
})(ButtonColor = exports.ButtonColor || (exports.ButtonColor = {}));
var ButtonType;
(function (ButtonType) {
    ButtonType["Submit"] = "submit";
    ButtonType["Default"] = "button";
    ButtonType["Reset"] = "reset";
})(ButtonType = exports.ButtonType || (exports.ButtonType = {}));
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["XSmall"] = "XSmall";
    ButtonSize["Small"] = "Small";
    ButtonSize["Medium"] = "Medium";
    ButtonSize["Large"] = "Large";
    ButtonSize["XLarge"] = "XLarge";
})(ButtonSize = exports.ButtonSize || (exports.ButtonSize = {}));
var ButtonStyle;
(function (ButtonStyle) {
    ButtonStyle["Primary"] = "Primary";
    ButtonStyle["Secondary"] = "Secondary";
    ButtonStyle["Transparent"] = "Transparent";
})(ButtonStyle = exports.ButtonStyle || (exports.ButtonStyle = {}));
var ButtonIconPosition;
(function (ButtonIconPosition) {
    ButtonIconPosition["Right"] = "Right";
    ButtonIconPosition["Left"] = "Left";
})(ButtonIconPosition = exports.ButtonIconPosition || (exports.ButtonIconPosition = {}));
//# sourceMappingURL=Button.types.js.map